<template>
    <ui-select-2
        v-model="selected"
        :label="label"
        :data="sponsorOptions"
        :loading="loader"
        :disabled="disabled"
        :text-items="[ 'group_name' ]"
        cover="photo"
        search-event="sponsors"
        ajax-search
        item-label="label"
        @input="handle"
    />
</template>

<script>
    import { uiSelect2 } from '@/components/ui/form'
    import { storage } from "@/services/storage"
    import { user } from '@/services/axios'
    import { mapGetters } from 'vuex'
    import helpers from '@/mixins/helpers'

    import axios from 'axios'

    export default {
        props: {
            value: {
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: 'Responsável:'
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        components: {
            uiSelect2
        },

        mixins: [helpers],

        data() {
            return {
                selected: null,
                loader: false,
                sponsorOptions: [],
                page: 1,
                totalPages: 1,
                cancelToken: null,
                groups: [],
                names: {
                    admin: storage.get('label_admin'),
                    collaborator: storage.get('label_collaborator'),
                    supervisor: storage.get('label_supervisor'),
                    manager: storage.get('label_manager'),
                    broker: storage.get('label_broker'),
                },
            }
        },

        computed: {
			...mapGetters('auth', {
				user: 'getUser'
			}),

            isSupervisor() {
                return this.user.user_group === 'supervisor'
            },

            isManager() {
                return this.user.user_group === 'manager'
            }
        },

        mounted() {
            this.$root.$on('select2-ajax-search-sponsors', async (data) => {
                this.loader = true

                if (!data.nextPage) {
                    this.page = 1
                    this.totalPages = null
                } else {
                    if (this.page > this.totalPages) {
                        this.page = this.page ++
                    } else {
                        this.loader = false
                        return 
                    } 
                }

                let response = []

                if (this.cancelToken) {
                    this.cancelToken.cancel()
                    this.cancelToken = axios.CancelToken.source()
                    response = await this.loadData(data.search)
                }else{
                    this.cancelToken = axios.CancelToken.source()
                    response = await this.loadData(data.search)
                }

                this.sponsorOptions = response
                this.loader = false
            })
        },

        beforeDestroy() {
            this.$root.$off('select2-ajax-search-sponsors')
        },

        methods: {
            handle() {
                this.$emit('input', this.selected)
            },

            async loadData(search) {
				try {
					let params = {
						q: search,
						supervisors: this.isSupervisor ? this.user.team.map(e => e.id).join(',') : null,
						managers: this.isManager ? this.user.manager_id : null,
						groups: null,
						per_page: 100,
						page: this.page,
					}
					switch (this.user.user_group) {
						case 'supervisor':
							params.groups = ['broker', 'manager'].join(',')
							break;
						case 'broker':
                        case 'manager':
							params.groups = 'broker'
							break;
						default:
							params.groups = this.groups.join(',')
							break;
					}

                    const response = await user.getAll('filter', params, {
						cancelToken: this.cancelToken.token
					})

                    this.totalPages = response.data.last_page

					return response.data.data.map(e => {
						e.group_name = this.names[e.group]
						e.cover = this.getImgCDN(e.photo)
                        e.label = e.first_name
						return e
					})
				} catch (error) {
					return []
				}
            },

            async loadGroups(){
                const response = await user.getAll('groups', {})

                this.groups = Object.values(response.data)
                                    .filter(group => group.name !== 'system')
                                    .map(group => {
                                        return group.name
                                    })
            }
        },

        async created(){
            await this.loadGroups()
        },

        watch: {
            value(newVal) {
                if (!newVal) {
                    this.sponsorOptions = []
                    this.selected = []
                    this.$emit('input', null)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>